// Simple utility functions for AssetDetailsComponent

export const getTemplateType = (machineryType: string): string | undefined => {
  if (machineryType === "HME") return "hme";
  if (machineryType === "Locomotive") return "locomotive";
  if (machineryType === "FixedPlant") return "fixedplant";
  return undefined;
};

export const needsTemplates = (machineryType: string): boolean => {
  return machineryType === "HME" || machineryType === "Locomotive" || machineryType === "FixedPlant";
};

export const shouldShowConfigurationStep = (machineryType: string): boolean => {
  return machineryType === "HME" || machineryType === "Locomotive" || machineryType === "FixedPlant";
};

export const hasGreasePumps = (
  selectedTemplate: any,
  assetData: any,
  isEdit: boolean
): boolean => {
  if (selectedTemplate?.hasGreasePumps) return true;
  if (isEdit && assetData.assetTemplate?.hasGreasePumps) return true;
  if (isEdit && assetData.assetTemplate?.greasePumps?.length > 0) return true;
  return false;
};

export const usesAssetApi = (machineryType: string): boolean => {
  return machineryType === "HME" || machineryType === "Locomotive" || machineryType === "FixedPlant";
};
